import DashboardView from './DashboardView';
import KPIManagement from './KPIManagement';
import DashboardList from './DashboardList';
import { ANALYTICS } from '../../utils/constant';

const analyticsRoutes = [
  {
    path: '/analytics/dashboards',
    element: <DashboardList />,
    permission: ANALYTICS,
  },
  {
    path: '/analytics/dashboards/:id',
    element: <DashboardView />,
    permission: ANALYTICS,
  },
  {
    path: '/analytics/kpis',
    element: <KPIManagement />,
    permission: ANALYTICS,
  },
];

export default analyticsRoutes;
